import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editFeaturesGroup, 
        deleteCards, 
        editCards, 
        popUpMessageChange, 
        editFigures, 
        popUpMenuChange} from '../../actions/index.js';

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';

class CloseConfirmation extends React.Component{

    handleClose = () => {
        this.props.popUpMessageChange({ show: false })
        this.props.popUpMenuChange({ 
            show: true
        });
    }

    handleConfirm = async () => {
        showMessage(this.props, _('Cerrando protocolo') + '...', { loading: true });
        const cardsGroupId = this.props.cardsGroupIds.toString()
        let urlPost = {
            'cards_group_id': cardsGroupId,
            'project_id': window.project_id,
            'closed': true,
        }
        let response = await postData('/web-api/update-cards-group-status', urlPost);
        this.handleResponse(response);
        // this.props.popUpMenuChange({ 
        //     show: true,
        //     expanded: true,
        // });
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            showMessage(this.props, '¡' + _('Protocolo Cerrado exitosamente') + '!', {messageTime:500});
            reloadCardsGroupsFeatures(this.props, [this.props.cardsGroupIds]);
        } else {
            showMessage(this.props, _('Ocurrió un error al cerrar el protocolo. Revisa si tiene pendientes.'), {messageTime:4000});
        }
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='confirm-success-button' onClick={ this.handleConfirm }>
                        { _('Cerrar') }
                    </Button>
                    <Button variant="contained" className='confirm-cancel-button' onClick={ this.handleClose }>
                        { _('Cancelar') }
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        editCards : editCards,
        deleteCards : deleteCards,
        editFeaturesGroup : editFeaturesGroup,
        popUpMessageChange : popUpMessageChange,
        editFigures : editFigures,
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CloseConfirmation)